import 'babel-polyfill';
import Es6Promise from 'es6-promise';
require('es6-promise').polyfill();
Es6Promise.polyfill();

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import '@/styles/index.scss' // global css

// import Vconsole from 'vconsole'
// // 在 非正式环境 环境才使用
// const env = sessionStorage.getItem('env')
// env != 'prod' ? new Vconsole() : ''
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
